import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  ScrapeCoupangArgs,
  TriggerBatchResponse,
  BatchJobsResponse,
  JobStatus,
  CommandName,
} from '../../../infrastructure/BatchClient';
import { BatchClient } from '../../../infrastructure/BatchClient';
import { glowpickClient } from '../../../infrastructure/GlowpickClient';
import { getConfig } from '../../../config';

const batchClient = new BatchClient(getConfig().apiUrl);

export const useTriggerScrapeCoupangBatch = () => {
  return useMutation<TriggerBatchResponse, Error, ScrapeCoupangArgs>({
    mutationFn: (args: ScrapeCoupangArgs) => batchClient.triggerScrapeCoupangJob(args),
    onSuccess: (data) => {
      console.info('✅ Scrape Coupang batch job triggered successfully:', data);
    },
    onError: (error) => {
      console.error('❌ Failed to trigger Scrape Coupang batch job:', error);
    },
  });
};

export const useBatchJobs = (options?: { status?: JobStatus | 'all'; commandName?: CommandName }) => {
  return useQuery<BatchJobsResponse, Error>({
    queryKey: ['batchJobs', options],
    queryFn: () => batchClient.listBatchJobs(options),
    refetchInterval: 5000, // Refetch every 5 seconds to get updated status
    staleTime: 1000, // Consider data stale after 1 second
  });
};

export const useCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: () => glowpickClient.getAllCategories(),
    staleTime: 1000 * 60 * 30, // 30 minutes
    gcTime: 1000 * 60 * 60, // 1 hour (renamed from cacheTime in newer versions)
  });
};
